// Marlow Product Accessories
(function() {
  'use strict';
  
  var section = document.querySelector('.marlow-product-accessories');
  if (!section) return;
  
  var cards = section.querySelectorAll('.marlow-product-accessories__card');
  
  cards.forEach(function(card) {
    var checkbox = card.querySelector('.marlow-product-accessories__checkbox');
    
    if (!checkbox) return;
    
    checkbox.addEventListener('change', function() {
      card.classList.toggle('is-selected', this.checked);
      updateButton();
    });
  });
  
  var button = section.querySelector('.marlow-product-accessories__add-btn');
  
  if (button) {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      
      var selected = [];
      section.querySelectorAll('.marlow-product-accessories__checkbox:checked').forEach(function(cb) {
        var id = parseInt(cb.dataset.variantId, 10);
        if (id && !isNaN(id)) selected.push({id: id, quantity: 1});
      });
      
      if (selected.length === 0) {
        showNotification('Please select at least one accessory', 'warning');
        return;
      }
      
      // Loading state
      var originalText = button.innerHTML;
      button.innerHTML = '<span>Adding...</span>';
      button.disabled = true;
      
      // Add to cart
      var xhr = new XMLHttpRequest();
      xhr.open('POST', '/cart/add.js', true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.onload = function() {
        if (xhr.status >= 200 && xhr.status < 300) {
          // Success
          showNotification(selected.length + ' item(s) added to cart!', 'success');
          
          // Clear selections
          section.querySelectorAll('.marlow-product-accessories__checkbox').forEach(function(cb) {
            cb.checked = false;
            var c = cb.closest('.marlow-product-accessories__card');
            if (c) c.classList.remove('is-selected');
          });
          updateButton();
          
          // Update cart counter
          updateCartCounter();
        } else {
          showNotification('Failed to add items. Please try again.', 'error');
        }
        button.innerHTML = originalText;
      };
      xhr.onerror = function() {
        showNotification('Network error. Please try again.', 'error');
        button.innerHTML = originalText;
        updateButton();
      };
      xhr.send(JSON.stringify({items: selected}));
    });
  }
  
  function updateButton() {
    if (!button) return;
    var checked = section.querySelectorAll('.marlow-product-accessories__checkbox:checked').length;
    var countSpan = button.querySelector('.marlow-product-accessories__add-btn-count');
    
    button.disabled = checked === 0;
    button.style.opacity = checked === 0 ? '0.5' : '1';
    if (countSpan) {
      countSpan.textContent = '(' + checked + ')';
      countSpan.style.display = checked > 0 ? 'inline' : 'none';
    }
  }
  
  // Custom notification (not browser alert)
  function showNotification(message, type) {
    // Remove existing
    var existing = document.querySelector('.marlow-accessories-notification');
    if (existing) existing.remove();
    
    var colors = {
      success: '#9A7840', // gold
      error: '#C74B4B',   // red
      warning: '#F5A623'  // orange
    };
    
    var notification = document.createElement('div');
    notification.className = 'marlow-accessories-notification';
    notification.innerHTML = `
      <span style="margin-right: 8px;">${type === 'success' ? '✓' : type === 'error' ? '✕' : '!'}</span>
      <span>${message}</span>
    `;
    notification.style.cssText = `
      position: fixed;
      top: 100px;
      right: 20px;
      background: ${colors[type] || colors.success};
      color: white;
      padding: 16px 24px;
      border-radius: 4px;
      font-family: var(--font-body, 'Jost', sans-serif);
      font-size: 14px;
      z-index: 10000;
      display: flex;
      align-items: center;
      box-shadow: 0 4px 12px rgba(0,0,0,0.15);
      animation: slideInRight 0.3s ease;
    `;
    
    document.body.appendChild(notification);
    
    setTimeout(function() {
      notification.style.animation = 'slideOutRight 0.3s ease';
      setTimeout(function() { notification.remove(); }, 300);
    }, 3000);
  }
  
  // Update cart counter in header
  function updateCartCounter() {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', '/cart.js', true);
    xhr.onload = function() {
      if (xhr.status === 200) {
        try {
          var cart = JSON.parse(xhr.responseText);
          
          // Try multiple selectors for cart count elements
          var selectors = [
            '.cart-count',
            '.cart-badge',
            '[data-cart-count]',
            '.header__cart-count',
            '.marlow-header__badge'
          ];
          
          selectors.forEach(function(selector) {
            document.querySelectorAll(selector).forEach(function(el) {
              el.textContent = cart.item_count;
              el.style.display = cart.item_count > 0 ? 'inline-block' : 'none';
            });
          });
          
          // Dispatch cart updated event for other components
          document.dispatchEvent(new CustomEvent('cart:updated', {
            detail: { cart: cart }
          }));
          
        } catch(e) {}
      }
    };
    xhr.send();
  }
  
  // Add animation styles
  if (!document.getElementById('marlow-accessories-styles')) {
    var style = document.createElement('style');
    style.id = 'marlow-accessories-styles';
    style.textContent = `
      @keyframes slideInRight {
        from { transform: translateX(100%); opacity: 0; }
        to { transform: translateX(0); opacity: 1; }
      }
      @keyframes slideOutRight {
        from { transform: translateX(0); opacity: 1; }
        to { transform: translateX(100%); opacity: 0; }
      }
    `;
    document.head.appendChild(style);
  }
  
  // Initial state
  updateButton();
  
})();
